<template>

  <section class="o-section">
    <div class="o-section__wrapper is-bottom-left" ref="wrapper">

      <div class="o-section__text" v-if="active">
        <div ref="textA" data-scene="1a">
          <div v-for="line in copy.top" v-html="line" :key="line"></div>
        </div>
        <div ref="textB" data-scene="1b">
          <div v-for="line in copy.bottom" v-html="line" :key="line"></div>
        </div>
      </div>

      <div class="o-section__figure-wrapper" v-if="active">
        <figure class="o-section__figure" ref="figureA" data-scene="1a">
          <Img :src="require('@/assets/scene1/spread1_a.png')" filename="spread1_a" />
        </figure>

        <figure class="o-section__figure anim-scene-1" ref="figureB2" data-scene="1b2">
          <Img :src="require('@/assets/scene1/spread1_b2.png')" filename="spread1_b2" />
        </figure>

        <figure class="o-section__figure" ref="figureB" data-scene="1b">
          <Img :src="require('@/assets/scene1/spread1_b.png')" filename="spread1_b" />
        </figure>
      </div>
    </div>
  </section>

</template>

<script>
import Img from '@/components/Img'

export default {
  name: 'Scene1',
  props: ['active', 'options', 'copy', 'disableBlur'],

  data () {
    return {
      ctx: ''
    }
  },

  mounted () {
    this.$root.$on('startScene1', () => {
      this.init()
    })
  },

  methods: {
    init () {
      this.$anime({
        targets: [this.$refs.figureB, this.$refs.figureB2],
        translateY: ['20px', '0'],
        duration: this.options.durationLarge,
        easing: this.options.easing
      })

      this.$anime({
        targets: this.$refs.figureB2.querySelector('div'),
        rotate: ['0', '5deg'],
        duration: 250,
        loop: true,
        direction: 'alternate',
        delay: 750,
        easing: this.options.easing
      })

      if (this.disableBlur) {
        this.$anime({
          targets: this.$refs.figureA,
          translateY: ['40px', '0'],
          opacity: [0, 1],
          duration: this.options.durationLarge,
          easing: this.options.easing
        })
      } else {
        this.$anime({
          targets: this.$refs.figureA,
          translateY: ['40px', '0'],
          filter: ['blur(15px)', 'blur(0px)'],
          duration: this.options.durationLarge,
          easing: this.options.easing
        })
      }
    }
  },

  components: {
    Img
  }
}
</script>
